import axios from 'axios';

if(process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = 'https://compassapiproduction.azurewebsites.net/api';
}
else {
    axios.defaults.baseURL = 'https://compassapiproduction.azurewebsites.net/api' //https://compassapi.azurewebsites.net/api
}

export default axios;